import { setErrorDialog, serverUrl, getheader } from "./CommonFunctions";

export const nationalUrl = serverUrl + "api/CustomersAPI/SearchNationalCode";
export function GetStaffList(Name) {
  var token = localStorage.getItem('token')
  return dispatch => {

    dispatch({
      type: 'LOADING',
      data: true,
    })

    fetch(serverUrl + "api/CustomersApi/GetStaff/?name=" + Name, {
      headers: getheader(),
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {

        dispatch({
          type: 'LOADING',
          data: false,
        })
        return dispatch({
          type: "GET_STAFF",
          data: res
        })
      }).catch(err => console.error('[err]', err));
  };
}
export function SaveRefer(ServiceID, ServiceType, StaffID, fn) {
  
  return dispatch => {

    dispatch({
      type: 'LOADING',
      data: true,
    })

    fetch(serverUrl + `ReceptionTasksApi/UpdateManageSendingStaff/?ServiceType=${ServiceType}&ServiceID=${ServiceID}&StaffID=${StaffID}`, {
      headers: getheader(),
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {


        dispatch({
          type: 'LOADING',
          data: false,
        })

        if (res === 202 || res === "202") {
          fn();

          return dispatch({
            type: "SAVE_REFER",
            data: true
          })

        }

        return dispatch({
          type: "SAVE_REFER",
          data: false
        })
      }).catch(err => console.error('[err]', err));
  };
}
export function AddNewCustomer(data, fn) {
  const _header = getheader();
  data.RegisteredFromSite = true;
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + "api/CustomersAPI/AddCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res === "ErrorNationalCode") {
          alert("کاربری با این شماره ملی در سیستم وجود دارد");
          return;
        }
        if (res === "ErrorMobile") {
          alert("کاربری با این شماره موبایل در سیستم وجود دارد");
          return;
        }
        if (res === "ErrorPhone") {
          alert("کاربر دیگری با این شماره تلفن در سیستم وجود دارد");
          return;
        }
        fn();
        return dispatch({
          type: "ADD_CUSTOMER",
          data: res
        });
      }).catch(err => {
        console.error('[ADD_CUSTOMER]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  }
}
export function editCustomerInfo(data, fn) {
  const _header = getheader();
  data.RegisteredFromSite = true;
  const editedInfo = data;
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + "api/CustomersAPI/EditCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res === "ErrorNationalCode") {
          alert("کاربری با این شماره ملی در سیستم وجود دارد");
          return;
        }
        fn();
        dispatch({
          type: "FETCH_CURRENT_CUSTOMER",
          data: editedInfo
        });
        return dispatch({
          type: "Edit_CUSTOMER",
          data: res
        });
      }).catch(err => {
        console.error('[Edit_CUSTOMER]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  }
}
export function getCustomerInfo(fn) {
  const _header = getheader();
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerInfo", {
      headers: _header,
      mode: "cors",
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        return dispatch({
          type: "FETCH_CURRENT_CUSTOMER",
          data: resp
        })
      }).catch(err => {
        console.log("[FETCH_CURRENT_CUSTOMER]", err);
      })
  }
}
export function setNewPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/SetNewPassword", {
      headers: getheader(),
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert("عملیات با موفقیت انجام شد. از نرم افزار خارج شده و دوباره وارد شوید");
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound" || resp.Message === "NotExists") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function forgetPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    let mobile = data.StringValue;
    data.ID = 0;
    data.Value = 0;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/ForgetPassword", {
      headers: {
        // 'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'credentials': 'include'
      },
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert(`رمز جدید به شماره موبایل ${mobile} ارسال شد`);
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        else if (resp && !resp.Message) {
          let respArray = "";
          for (let i = 0; i < resp.length; i++) {
            respArray = resp[i].SMSNumber + ":" + resp[i].SendResult + "\n";
          }
          alert(respArray);
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function getCustomerEvents(data) {
  return dispatch => {
    dispatch({
      type: "CUSTOMER_EVENTS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerEvents", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "CUSTOMER_EVENTS",
          data: res
        })
      })
      .catch(e => {
        dispatch({
          type: "CUSTOMER_EVENTS",
          data: { Message: "Error" }
        })
        console.log("[CUSTOMER_EVENTS]", e);
      });
  }
}
export function getRemainedAccount(id, cat, fn) {
  fetch(serverUrl + `api/DocumentsAPI/GetRemainedAccount?accountID=${id}&accountCat=${cat}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => {
      if (fn) {
        fn(res);
      }
    }
    ).catch(e => {
      console.log("[GetRemainedAccount]", e);
      const r = { RemainedAccount: -1, Type: "", color: "black" }
      fn(r);
    })
}
export function addCustomerTicket(ticket, fn) {
  ticket.ByCustomer = true;
  return dispatch => {
    fetch(serverUrl + `api/CustomersAPI/AddCustomerTicket`, {
      body: JSON.stringify(ticket),
      method: "POST",
      headers: getheader()
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت تیکت");
          return;
        }
        fn(res);
      })
      .catch(e => console.log("[ADD_CUSTOMER_TICKET]", e));
  }
}
export function getCustomerTicket(id, fn) {
  return dispatch => {
    fetch(serverUrl + `api/CustomersAPI/GetCustomerTicket?byCustomer=true&id=${id}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات تیکت");
          return;
        }
        fn(res);
      })
      .catch(e => console.log("[GET_CUSTOMER_TICKET]", e));
  }
}
export function getCustomerTicketList(filters) {
  return dispatch => {
    dispatch({
      type: "GET_CUSTOMER_TICKETS",
      data: "PENDING"
    })
    fetch(serverUrl + `api/CustomersAPI/GetCustomerTicketList`, {
      headers: getheader(),
      body: JSON.stringify(filters),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "لیست تیکت ها");
          return;
        }
        dispatch({
          type: "GET_CUSTOMER_TICKETS",
          data: res
        })
      })
      .catch(e => console.log("[GET_CUSTOMER_TICKETS]", e));
  }
}
export function getCustomerTicketList_Local(data) {
  return dispatch => {
    dispatch({
      type: "GET_CUSTOMER_TICKETS",
      data: data
    })
  }
}
export function getCustomerNoticeBag(isRead) {
  return dispatch => {
    dispatch({
      type: "GET_CUSTOMER_NOTICES",
      data: "PENDING"
    })
    fetch(serverUrl + `api/NoticeBoardAPI/GetCustomerNoticeBag?isRead=${isRead}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "لیست اطلاعیه ها");
          return;
        }
        dispatch({
          type: "GET_CUSTOMER_NOTICES",
          data: res
        })
      })
      .catch(e => console.log("[GET_CUSTOMER_NOTICES]", e));
  }
}
export function setNoticeToRead(id) {
  return dispatch => {
    fetch(serverUrl + `api/NoticeBoardAPI/SetNoticeToRead?id=${id}&getList=true`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, " اطلاعیه ها");
          return;
        }
        if (res.Data) {
          dispatch({
            type: "GET_CUSTOMER_NOTICES",
            data: res
          })
        }
      })
      .catch(e => console.log("[SetNoticeToRead]", e));
  }
}
export function addPreCustomerProduct(data, fn) {
  return dispatch => {
    const _header = getheader();
    let product = { ...data };
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/AddPreCustomerProduct/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت درخواست محصول");
          return;
        }

        product.ID = Number(res.ID);
        fn(product);
        setErrorDialog(dispatch, "success", "ثبت درخواست محصول");
      }).catch(err => {
        console.error('[ADD_PRECUSTOMER_PRODUCT]', err);
      });
  }
}
export function addPreCustomerProducts(data, fn) {
  return dispatch => {
    const _header = getheader();
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/AddPreCustomerProducts/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت درخواست محصول");
          return;
        }
        if (res.Data)
          fn(res);
        setErrorDialog(dispatch, "success", "ثبت درخواست محصول");
      }).catch(err => {
        console.error('[ADD_PRECUSTOMER_PRODUCT]', err);
      });
  }
}
export function getCustomerProductList_Local(data) {
  return dispatch => {
    dispatch({
      type: "CUSTOMER_PRODUCT_LIST",
      data: data
    })
  }
}
export function getCustomerProductList(customerID) {
  return dispatch => {

    dispatch({
      type: "CUSTOMER_PRODUCT_LIST",
      data: "PENDING"
    })
    fetch(serverUrl + `api/CustomersAPI/GetPreCustomerProductList?customerID=${customerID}&isPreCustomer=false`, {
      headers: getheader(),
      cache: "no-cache",
      method: "GET"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "لیست محصولات مشتریان ");
          return;
        }
        dispatch({
          type: "CUSTOMER_PRODUCT_LIST",
          data: res
        })
      }).catch(err => {
        console.error('[CUSTOMER_PRODUCT_LIST]', err);
      });
  }
}
export function deletePreCustomerProduct(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeletePreCustomerProduct", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف محصول درخواستی");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف محصول درخواستی");
        if (fn) {
          fn(res);
        }
      })
  }
}
